import RightPopupComponent from "components/RightPopup";

import Template from "pages/clients/components/filterPopup/components/template";

import './index.less';
import './themes/default.less';

export default class FilterPopup extends RightPopupComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            selectedMenu: false,
            buferFilter: [],
            book: {}
        };

        this.terms = [
            "Статус пациента",
            "Возраст",
            "Дата рождения",
            /*"Месяц рождения",*/
            "Пол",
            "Врач",
            "Координатор",
            "Клиника",
            /*"Даты визитов",
            "Последний визит",
            "Нет ни одного приема",
            "Причина обращения",*/
            "Источник регистрации",
        ];
    }

    show(info, hideCb) {
        this.state.info = { ...this.state.info, ...info };

        this.dialogTitle = "Фильтры";
        this.dialogSaveTitle = "Применить";
        this.hidCb = hideCb;

        const { clientStatuses } = this._config;
        const sex = [
            { id: 1, name: "Мужской" },
            { id: 2, name: "Женский" }
        ];

        const ageItems = Array.from({ length: 99 }, (_, i) => ({ id: i + 1, name: `${i + 1}` }));

        const date = new Date();
        const months = new Array(12).fill(0).map((it, i) => {
            const newDate = new Date(date.getFullYear(), i, 1);
            const name = this._helper.date.toStr(newDate, "MMMM");
            return { id: i + 1, name: this._helper.string.capitalize(name) };
        });

        const clinics = this._helper.getClinics();

        const { reasons, recommendationTypes } = globalThis.appPageView.state;

        this.state.book = {
            "status": { rows: clientStatuses, label: "client.status", state: "status" },
            "age": { rows: ageItems, label: "Возраст", state: "age" },
            "months": { rows: months, label: "Месяц рождения", state: "month" },
            "sex": { rows: sex, label: "Пол", state: "sex" },
            "clinics": { rows: clinics, label: "Клиника", state: "clinic" },
            "reasons": { rows: reasons, label: "Причина обращения", state: "reason" },
            "recommendationTypes": { rows: recommendationTypes, label: "Источник регистрации", state: "recommendationType" }
        };

        super.show();
    }

    changeCurrentMenu(i) {
        this.setState({ selectedMenu: i });
    }

    renderMenuCat(title, i) {
        const { selectedMenu } = this.state;

        return (
            <div
                key={"menuCat" + i}
                className={`rowMenu rad4 ${selectedMenu === i ? "active" : ""}`}
                onClick={this.changeCurrentMenu.bind(this, i)}>
                <div className="flex gap8 centerV">
                    <div className="name text p1SemiBold">{title}</div>
                </div>
            </div>
        );
    }

    save() {
        const { buferFilter } = this.state;

        if (this.hidCb?.apply)
            this.hidCb(buferFilter);

        this.hide();
    }

    renderContent() {
        const { selectedMenu, buferFilter, book } = this.state;

        return (<div className="filterPopup flex gap24 col">
            <div className="flex">
                <div className="leftSide flex col gap4">
                    {this.terms.map((it, i) => this.renderMenuCat(it, i))}
                </div>
                <div className="rightSide">
                    <Template
                        selectedMenu={selectedMenu}
                        buferFilter={buferFilter}
                        book={book}
                        changeState={this.changeState.bind(this, "buferFilter")} />
                </div>
            </div>
        </div>);
    }
}

